"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = exports.CardsGrid = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../mantine-theme/src");
var Paper_1 = require("../Paper/Paper");
var Card_styles_1 = __importDefault(require("./Card.styles"));
var CardsGrid_1 = require("./CardsGrid/CardsGrid");
Object.defineProperty(exports, "CardsGrid", { enumerable: true, get: function () { return CardsGrid_1.CardsGrid; } });
function Card(_a) {
    var className = _a.className, themeOverride = _a.themeOverride, _b = _a.padding, padding = _b === void 0 ? 'md' : _b, _c = _a.radius, radius = _c === void 0 ? 'sm' : _c, others = __rest(_a, ["className", "themeOverride", "padding", "radius"]);
    var classes = Card_styles_1.default({ radius: radius, padding: padding, theme: theme_1.useMantineTheme(themeOverride) });
    return (react_1.default.createElement(Paper_1.Paper, __assign({ "data-mantine-card": true, className: clsx_1.default(classes.card, className), radius: radius, padding: padding }, others)));
}
exports.Card = Card;
Card.displayName = '@mantine/core/Card';
